import React, { Fragment } from 'react';
import loadable from '@loadable/component';
import Hamburger from '@/components/icons/hamburger';
import Close from '@/components/icons/close';
import { compose, render } from '@/utils/story-composer';
import MenuContext from '@/context/menu-context';

const Transition = loadable(() => import('@headlessui/react').then(headlessUi => headlessUi.Transition), { ssr: true });

function Navigation({ items, pageContext }) {
	const { location } = pageContext;

	const topMenu = render(items, { place: 'top', location });
	const sideMenu = render(items, { place: 'side', location });

	return pageContext.place === 'top' ? (
		<>
			<MenuContext.Consumer>
				{({ openMenu, closeMenu, menuOpen }) => (
					<button
						type="button"
						aria-label="mobile menu button"
						onClick={menuOpen ? closeMenu : openMenu}
						className="lg:hidden"
					>
						{menuOpen ? <Close /> : <Hamburger />}
					</button>
				)}
			</MenuContext.Consumer>
			<nav className="hidden lg:block">
				<div className="flex flex-row items-center">{topMenu}</div>
			</nav>
		</>
	) : (
		<MenuContext.Consumer>
			{({ menuOpen }) => (
				<Transition
					as={Fragment}
					enter="transition ease-out duration-300"
					enterFrom="opacity-0 -translate-y-4"
					enterTo="opacity-100 translate-y-0"
					leave="transition ease-in duration-200"
					leaveFrom="opacity-100 translate-y-0"
					leaveTo="opacity-0 -translate-y-4"
					show={menuOpen}
				>
					<div className="w-full max-h-screen overflow-scroll bg-white flex pt-24 flex-col">
						<nav>{sideMenu}</nav>
						<div className="mt-5 mb-8 ml-5">{pageContext.buttonsSideMenu}</div>
					</div>
				</Transition>
			)}
		</MenuContext.Consumer>
	);
}

export default Navigation;

compose('navigation', Navigation);
